module.exports = {
  src: __webpack_public_path__ + "static/media/frontpage_00016.ae7c7e92.jpg",
  width: 2000,
  height: 1600,
  bytes: 224808,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/frontpage_00016.ae7c7e92.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/frontpage/frontpage_00016.jpg
// module id = 177
// module chunks = 0